import fp from 'lodash/fp';

// eslint-disable-next-line import/prefer-default-export
export const combineColumnPreferences = (realColumns, preferenceColumns) => ([
    ...preferenceColumns
        .filter(prefCol => realColumns.find(realCol => realCol.id === prefCol.id))
        .map(prefCol => ({
            ...realColumns.find(realCol => realCol.id === prefCol.id),
            ...fp.pick(['width', 'visible'])(prefCol)
        })),
    ...realColumns
        .filter(col => !preferenceColumns.find(prefCol => col.id === prefCol.id))
]);
